(() => {
  'use strict';
  document.querySelectorAll('[data-amc-rack-gallery]').forEach(gallery => {
    if (gallery.dataset.rackReady) return;
    gallery.dataset.rackReady = 'true';
    const image = gallery.querySelector('[data-rack-image]');
    const full = gallery.querySelector('[data-rack-full]');
    const caption = gallery.querySelector('[data-rack-caption]');
    gallery.querySelectorAll('[data-rack-source]').forEach(button => {
      button.addEventListener('click', () => {
        image.src = button.dataset.rackSource;
        image.alt = button.dataset.rackAlt;
        full.href = button.dataset.rackSource;
        caption.textContent = button.dataset.rackAlt;
        gallery.querySelectorAll('[data-rack-source]').forEach(control =>
          control.setAttribute('aria-pressed', String(control === button)));
      });
    });
  });
})();
